export default "__VITE_ASSET__54477312__"